<template>
  <section
    class="hero section center-content"
    :class="[
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color'
    ]">
    <div class="container-sm">
      <div
        class="hero-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider'
        ]">
        <div class="hero-content">
          <h1 class="mt-0 mb-12 reveal-scale-down" data-reveal-delay="300">
            From Tedious To Easiest
          </h1>
          <div class="container-xs">
            <p class="m-0 mb-32 reveal-scale-down" data-reveal-delay="400">
              Automatically document, log, and track your recurring tasks.<br> 
              Never lose time wondering "how did we do this last time" or "who has those documents" ever again.
            </p>
            <div class="reveal-scale-down" data-reveal-delay="500">
              <c-button tag="a" color="primary" href="https://cruip.com/" wide-mobile>Learn More</c-button>
            </div>
          </div>
        </div>
        <div class="hero-figure illustration-element-01 reveal-scale-down" data-reveal-delay="600">
          <c-image
            class="has-shadow"
            :src="require('@/assets/images/hero-image.png')"
            alt="Hero"
            :width="896"
            :height="502" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'
import CButton from '@/components/elements/Button.vue'
import CImage from '@/components/elements/Image.vue'

export default {
 name: 'CHeroFull',
 mixins: [SectionProps],
 components: {
  CButton,
  CImage
 }
}
</script>